import { type AppConfig, loadConfig, stripEmptyStrings } from '@fuze/portal-core';

const RUNTIME_CONFIG_GLOBAL = '__ONWARD_CONFIG__';

/**
 * Runtime config arrives as /config.js, which sets window.__ONWARD_CONFIG__ before the app loads. nginx renders
 * it from environment variables at container start (docker/config.js.template); the Vite dev server renders the
 * same shape from .env (vite.config.ts). The bundle itself contains no environment-specific values.
 */
export const loadRuntimeConfig = (): AppConfig => {
  const raw = (window as unknown as Record<string, unknown>)[RUNTIME_CONFIG_GLOBAL];
  if (raw === undefined) {
    throw new Error('Runtime config is missing: /config.js did not load before the app.');
  }
  return loadConfig(stripEmptyStrings(raw));
};
